import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxdbAdaptorProvider } from './rxdb-adaptor.provider';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [RxdbAdaptorProvider]
})
export class InfrastructureModule {}
